import moment from "moment";
import { SIEMBA_ADMIN, SIEMBA_CUSTOMER, SIEMBA_CUSTOMER_ENGINEER, SIEMBA_TESTER } from "../../../utils/roles";
import { getSessionDetails } from "../../../hooks/siembagpt";

export function hasGenptDeferExpiringTomorrowDate(notification) {
    const raw = notification?.deferred_finding_date;
    return raw != null && String(raw).trim() !== '';
}

export function formatGenptDeferExpiringTomorrowDateLabel(raw) {
    const trimmed = String(raw).trim();
    const m = moment(trimmed);
    if (!m.isValid()) return trimmed;
    return m.format('MMMM D, YYYY');
}

export const getUserAvatarDetails = (notification) => {
    const user = {
        first_name: " ",
        profile_picture: "",
        last_name: " "
    };
    switch (notification.type) {
        case "INVITE_USER":
        case "FINDING_CUSTOMER_ASSIGNED":
        case "PENTEST_CREATED":
        case "PENTEST_DRAFTED":
        case "PENTEST_DRAFT_DELETED":
        case "PENTEST_ASSET_ADDED":
        case "PENTEST_MANAGER_ADDED":
        case "PENTEST_MANAGER_REMOVED":
        case "ASSET_POC_ASSIGNED":
        case "ASSET_POC_REMOVED":
        case "PENTEST_ASSET_DELETED":
        case "ASSET_DELETE_REQUEST":
        case "PRE_REQUEST_SHARED":
        case "FINDING_STATUS_UPDATED":
        case "QUALYS_FINDING_STATUS_UPDATED":
        case "FINDING_EDITED":
        case "GENPT_FINDING_UPDATED":
        case "FINAL_REPORT_GENERATED":
        case "PRE_REQUEST_COMMENT":
        case "PRE_REQUEST_APPROVED":
        case "PENTEST_STATUS_CHANGED":
        case "ASSET_COMPLETION_CHANGED":
        case "ASSET_ASSIGNED":
        case "ASSET_UNASSIGNED":
        case "USER_STORY_ADDED":
        case "USER_STORY_EDITED":
        case "BLOCKER_ADDED":
        case "BLOCKER_STATUS_UPDATED":
        case "BLOCKER_EDITED":
        case "LATEST_STATUS_ADDED":
        case "POTENTIAL_FINDING_ADDED":
        case "OPEN_FINDING_ADDED":
        case "ASSET_STATUS_CHANGED":
        case "PENTEST_COMPLETION_CHANGED":
            user.first_name = notification?.init_user?.first_name;
            user.profile_picture = notification?.init_user?.profile_picture;
            break;
        case "FILL_PRE_REQUEST":
        case "PENTEST_NEXT_ITERATION":
        case "FILL_PREREQ_REMINDER":
        case "IMPORTED_ASSETS":
        case "START_GENPT_TEST":
        case "GENPT_TEST_COMPLETED":
        case "GENPT_TEST_FAILED":
        case "START_GENPT_BULK_TEST":
        case "GENPT_SCHEDULE_CREATED":
        case "GENPT_SCHEDULE_UPDATED":
        case "GENPT_SCHEDULE_PAUSED":
        case "GENPT_SCHEDULE_RESUMED":
        case "GENPT_SCHEDULE_DELETED":
        case "SCHEDULE_START_GENPT_TEST":
        case "SCHEDULE_GENPT_TEST_COMPLETED":
        case "SCHEDULE_GENPT_TEST_FAILED_AUTH":
        case "SCHEDULE_GENPT_TEST_FAILED":
        case "SCHEDULE_GENPT_TEST_EXECUTION_FAILED":
        case "SCHEDULE_GENPT_TEST_DEFERRED":
        case "GENPT_DEFER_EXPIRING_TOMORROW":
            user.first_name = notification?.init_user?.first_name;
            user.last_name = notification?.init_user?.last_name;
            break;
        case "FILL_PREREQ_REQUEST":
            user.profile_picture = "APP_LOGO";
            break;
        case "EASM_SCAN_COMPLETED":
        case "EASM_SCAN_FAILED":
            // Unlike the manually-triggered notifications above, EASM scans also finish from
            // the unattended monitoring cron (success or failure) — backend sends
            // init_user_id: null for those, so falling back to the user-avatar group
            // unconditionally would render "undefined undefined". Use the triggering user's
            // avatar only when one actually exists.
            if (notification?.init_user?.first_name) {
                user.first_name = notification?.init_user?.first_name;
                user.last_name = notification?.init_user?.last_name;
            } else {
                user.profile_picture = "APP_LOGO";
            }
            break;
        default:
            user.profile_picture = "APP_LOGO";
            break;
    }

    return user;
}


export const getNotificationAction = async (notification, mainUrl) => {
    const action = {
        type: "",
        url: "",
        id: "",
        assetId: "",
        pentestId: "",
        modalType: "",
        data: ""
    }


    switch (notification.type) {
        case "INVITE_USER":
        case "PENTEST_CREATED":
        case "PENTEST_STATUS_CHANGED":
        case "PENTEST_COMPLETION_CHANGED":
        case "PENTEST_NEXT_ITERATION":
        case "FINDING_CUSTOMER_ASSIGNED":
            action.type = "NAVIGATE";
            action.url = `${mainUrl}/pentests/all_findings/${notification?.finding?.id}/dashboard`;
            action.id = notification?.finding?.id;
            break;
        case "PENTEST_ASSET_DELETED":
            action.type = "NAVIGATE";
            action.url = `${mainUrl}/all_pentests/${notification?.pentest?.id}/dashboard`;
            action.id = notification?.pentest?.id;
            break;
        case "PENTEST_DRAFTED":
        case "PENTEST_DRAFT_DELETED":
            action.type = "NAVIGATE";
            action.url = `${mainUrl}/pentests/draft`;
            action.id = notification?.pentest?.id;
            break;
        case "PENTEST_ASSET_ADDED":
            action.type = "NAVIGATE";
            action.url = `${mainUrl}/all_pentests/${notification?.pentest?.id}/dashboard`;
            action.id = notification?.pentest?.id;
            break;
        case "PENTEST_MANAGER_ADDED":
            action.type = "NAVIGATE";
            action.url = `${mainUrl}/all_pentests/${notification?.pentest?.id}/dashboard`;
            action.id = notification?.pentest?.id;
            break;
        case "PENTEST_MANAGER_REMOVED":
            action.type = "NAVIGATE";
            action.url = `${mainUrl}/all_pentests/${notification?.pentest?.id}/dashboard`;
            action.id = notification?.pentest?.id;
            break;
        case "ASSET_POC_ASSIGNED":
            action.type = "NAVIGATE";
            action.url = `${mainUrl}/all_pentests/${notification?.pentest?.id}/dashboard`;
            action.id = notification?.pentest?.id;
            break;
        case "ASSET_POC_REMOVED":
            action.type = "NAVIGATE";
            action.url = `${mainUrl}/all_pentests/${notification?.pentest?.id}/dashboard`;
            action.id = notification?.pentest?.id;
            break;
        case "ASSET_DELETE_REQUEST":
        case "FILL_PRE_REQUEST":
        case "PRE_REQUEST_APPROVED":
        case "ASSET_COMPLETION_CHANGED":
        case "ASSET_ASSIGNED":
        case "ASSET_UNASSIGNED":
        case "LATEST_STATUS_ADDED":
        case "ASSET_STATUS_CHANGED":
        case "FILL_PREREQ_REMINDER":
        case "FILL_PREREQ_REQUEST":
            action.type = "NAVIGATE";
            action.url = `${mainUrl}/all_assets/${notification?.pentest_asset?.id}/dashboard`;
            action.id = notification?.pentest_asset?.id;
            break;
        case "PRE_REQUEST_SHARED":
            action.type = "NAVIGATE";
            action.url = `${mainUrl}/all_assets/${notification?.pentest_asset?.id}/pre_requisites`;
            action.id = notification?.pentest_asset?.id;
            break;
        case "PRE_REQUEST_COMMENT":
            action.type = "NAVIGATE";
            action.url = `${mainUrl}/all_assets/${notification?.pentest_asset?.id}/pre_requisites?question=${notification?.question_id}&category=${notification?.category_type}`;
            action.id = notification?.pentest_asset?.id;
            break;
        case "USER_STORY_ADDED":
        case "USER_STORY_EDITED":
            action.type = "NAVIGATE";
            action.url = `${mainUrl}/all_assets/${notification?.pentest_asset?.id}/asset_desc_and_user_stories`;
            action.id = notification?.pentest_asset?.id;
            break;
        case "POTENTIAL_FINDING_ADDED":
        case "OPEN_FINDING_ADDED":
        case "FINDING_STATUS_UPDATED":
        case "FINDING_EDITED":
            action.type = "NAVIGATE";
            action.url = `${mainUrl}/pentests/all_findings/${notification?.finding?.id}/dashboard`;
            action.id = notification?.finding?.id;
            break;
        case "QUALYS_FINDING_STATUS_UPDATED":
            action.type = "NAVIGATE";
            action.url = `${mainUrl}/va/all_findings/${notification?.va_id}/dashboard?assetId=${notification?.asset_id}`;
            action.id = notification?.va_id;
            break;
        case "GENPT_FINDING_UPDATED": {
            action.type = "NAVIGATE";
            const genptFindingId =
                notification?.genpt_finding_id ??
                notification?.genpt_finding?.id ??
                null;
            if (genptFindingId == null || String(genptFindingId).trim() === '') {
                action.url = `${mainUrl}/genpt/all_findings`;
                break;
            }
            action.url = `${mainUrl}/genpt/all_findings/${encodeURIComponent(
                String(genptFindingId).trim()
            )}/dashboard`;
            action.id = genptFindingId;
            break;
        }
        case "GENPT_DEFER_EXPIRING_TOMORROW": {
            if (moment(notification?.deferred_finding_date).isSameOrBefore(moment(), 'day')) {
                return "";
            }
            action.type = "NAVIGATE";
            const rawExpiresOnDate = notification?.deferred_finding_date
                ? moment(notification.deferred_finding_date).format('YYYY-MM-DD')
                : moment().add(1, 'day').format('YYYY-MM-DD');
            action.url = `${mainUrl}/genpt/all_findings?tab=2&expires_on=${encodeURIComponent(rawExpiresOnDate)}`;
            break;
        }
        case "EASM_SCAN_COMPLETED":
        case "EASM_SCAN_FAILED":
            // Same deep-link for both outcomes — backend carries only asset_id either way
            // (sendEasmScanNotification.js), and the summary tab is where the result shows up.
            action.type = "NAVIGATE";
            action.url = `${mainUrl}/easm/monitoring/${notification?.asset_id}/summary`;
            action.id = notification?.asset_id;
            break;
        case "BLOCKER_ADDED":
        case "BLOCKER_STATUS_UPDATED":
        case "BLOCKER_EDITED":
            action.type = "OPEN_MODAL";
            action.assetId = notification?.pentest_asset?.id;
            action.id = notification?.blocker?.id;
            action.url = `${mainUrl}/all_assets/${notification?.pentest_asset?.id}/dashboard`;
            action.modalType = "BLOCKER";
            break;
        case "FINAL_REPORT_GENERATED":
            action.type = "OPEN_MODAL";
            action.assetId = notification?.pentest_asset?.id;
            action.pentestId = notification?.pentest?.id;
            const report = notification?.report;
            report.generated_file = report?.url;
            report.key = report?.report_type;
            report.is_report_generated = true;
            report.title = reportNames[report?.report_type];
            action.data = report;
            action.modalType = "REPORT";
            break;
        case "IMPORTED_ASSETS":
            break;
        case "NOTIFY_PREREQUISITES":
            break;
        case "START_GENPT_TEST":
            action.type = "NAVIGATE";
            const sessionDetails = await getSessionDetails(notification?.session_id);

            if (sessionDetails?.session?.status === 'inprogress') {
                action.url = `${mainUrl}/genpt/tests/chat/${sessionDetails?.session?.chat_id}?targetURL=${encodeURIComponent(sessionDetails?.session?.target_url)}`;
            } else {
                action.url = `${mainUrl}/genpt/tests/${notification?.session_id}`;
            }
            break;
        case "START_GENPT_BULK_TEST":
            // Store the notification?.badge_id in session storage
            if (notification?.batch_id) {
                sessionStorage.setItem('batch_id', notification.batch_id);
            }
            action.type = "NAVIGATE";
            action.url = `${mainUrl}/genpt/tests/?badge_id=true`;
            break;
        case "GENPT_TEST_FAILED":
            action.type = "NAVIGATE";
            action.url = `${mainUrl}/genpt/tests/?status=failed&notificationTime=${notification?.genpt_notification_time}`;
            break;
        case "GENPT_TEST_COMPLETED":
            action.type = "NAVIGATE";
            action.url = `${mainUrl}/genpt/tests/?status=completed&notificationTime=${notification?.genpt_notification_time}`;
            break;
        case "GENPT_SCHEDULE_CREATED":
        case "GENPT_SCHEDULE_UPDATED":
        case "GENPT_SCHEDULE_PAUSED":
        case "GENPT_SCHEDULE_RESUMED":
        case "SCHEDULE_GENPT_TEST_DEFERRED":
        case "SCHEDULE_GENPT_RUN_SKIPPED_BY_FREEZE": {
            /**
             * All "this schedule changed" notifications deep-link to the AllSchedules page
             * with `previewScheduleId` (+ optional `previewScheduleName`) so the slide-in
             * preview auto-opens for the affected schedule (see `AllSchedules/index.js`).
             * Falls back to the bare listing if the notification payload doesn't carry an id.
             */
            action.type = "NAVIGATE";
            const sid =
                notification?.genpt_schedule_id ??
                notification?.genpt_schedule?.id ??
                null;
            if (sid == null || String(sid).trim() === '') {
                action.url = `${mainUrl}/genpt/schedules`;
                break;
            }
            const nm = notification?.genpt_schedule?.name;
            const nameQs =
                nm != null && String(nm).trim() !== ''
                    ? `&previewScheduleName=${encodeURIComponent(String(nm).trim())}`
                    : '';
            action.url = `${mainUrl}/genpt/schedules?previewScheduleId=${encodeURIComponent(
                String(sid).trim()
            )}${nameQs}`;
            break;
        }
        case "GENPT_SCHEDULE_DELETED":
            return "";
        case "SCHEDULE_START_GENPT_TEST": {
            action.type = "NAVIGATE";
            const scheduleStartDetails = await getSessionDetails(notification?.session_id);
            if (scheduleStartDetails?.session?.status === 'inprogress') {
                action.url = `${mainUrl}/genpt/tests/chat/${scheduleStartDetails?.session?.chat_id}?targetURL=${encodeURIComponent(
                    scheduleStartDetails?.session?.target_url
                )}`;
            } else {
                action.url = `${mainUrl}/genpt/tests/${notification?.session_id}`;
            }
            break;
        }
        case "SCHEDULE_GENPT_TEST_COMPLETED":
            action.type = "NAVIGATE";
            if (notification?.session_id != null && String(notification.session_id).trim() !== '') {
                action.url = `${mainUrl}/genpt/tests/${encodeURIComponent(
                    String(notification.session_id).trim()
                )}`;
            } else if (notification?.genpt_notification_time) {
                action.url = `${mainUrl}/genpt/tests/?status=completed&notificationTime=${notification?.genpt_notification_time}`;
            } else {
                action.url = `${mainUrl}/genpt/tests/?status=completed`;
            }
            break;
        case "SCHEDULE_GENPT_TEST_FAILED_AUTH":
        case "SCHEDULE_GENPT_TEST_FAILED": {
            action.type = "NAVIGATE";
            const failedSessionId =
                notification?.session_id ??
                notification?.genpt_session_id ??
                notification?.genpt_id ??
                null;
            if (failedSessionId != null && String(failedSessionId).trim() !== '') {
                action.url = `${mainUrl}/genpt/tests/${encodeURIComponent(
                    String(failedSessionId).trim()
                )}`;
            } else if (notification?.genpt_notification_time) {
                action.url = `${mainUrl}/genpt/tests/?status=failed&notificationTime=${notification?.genpt_notification_time}`;
            } else {
                action.url = `${mainUrl}/genpt/tests/?status=failed`;
            }
            break;
        }
        case "SCHEDULE_GENPT_TEST_EXECUTION_FAILED": {
            action.type = "NAVIGATE";
            const execSchId =
                notification?.genpt_schedule_id ?? notification?.genpt_schedule?.id ?? null;
            if (execSchId == null || String(execSchId).trim() === '') {
                action.url = `${mainUrl}/genpt/schedules`;
                break;
            }
            const execNm = notification?.genpt_schedule?.name;
            const execNameQs =
                execNm != null && String(execNm).trim() !== ''
                    ? `&historyScheduleName=${encodeURIComponent(String(execNm).trim())}`
                    : '';
            action.url = `${mainUrl}/genpt/schedules?historyScheduleId=${encodeURIComponent(
                String(execSchId).trim()
            )}${execNameQs}`;
            break;
        }
        default:
            return ""
    }

    return action;
}


export const getMainURL = (userRole) => {
    let mainUrl = "/app";
    if (userRole === SIEMBA_ADMIN) {
        mainUrl = "/admin";
    } else if (userRole === SIEMBA_TESTER) {
        mainUrl = "/tester";
    } else if (userRole === SIEMBA_CUSTOMER) {
        mainUrl = "/app";
    } else if (userRole === SIEMBA_CUSTOMER_ENGINEER) {
        mainUrl = "/app";
    }
    if (!userRole) {
        mainUrl = "/";
    }
    return mainUrl;
}

export const getNotificationTime = (date) => {
    try {
        if (date) {
            return moment(date).fromNow(true);
        }
    } catch (e) {
        console.log("Error while parsing date")
    }
}


export const roles = {
    pentest_manager: "Pentest Manager",
    pentest_overseer: "Pentest Overseer",
    asset_poc: "Point Of Contact"
}

export const reportNames = {
    asset_final_report: "Asset Final Report",
    pentest_draft_final_report: "Pentest Draft Final Report",
    asset_draft_final_report: "Asset Draft Final Report",
    asset_status_report: "Asset Status Report",
    pentest_status_report: "Pentest Status Report",
    asset_executive_report: "Asset Executive Report",
    pentest_final_report: "Asset Final Report",
    pentest_security_audit_certificate: "Pentest Security Audit Certificate Report",
    asset_engagement_letter: "Asset Engagement Letter Report",
    pentest_executive_report: "Pentest Executive Report",
    pentest_asset_security_audit_certificate: "Asset Security Audit Certificate Report",
    genpt_pdf_report: "Autonomous Vulnerability Test Report",
    easm_csv_report: "EASM CSV Report",
    monitoring_csv_report: "Monitoring CSV Report",
    pentest_custom_findings_report: "Pentest Custom Finding Report",
    asset_custom_findings_report: "Asset Custom Findings Report"
}